import React from 'react'
import NoData from "../assets/no-data.png"
function NotFound() {
  return (
    <div>
      <img src={NoData} alt="" />
    </div>
  )
}

export default NotFound
